/** @format */

import React from 'react';
import {handleChange, InputWithErrorHandler, SelectWithErrorHandler} from 'frontier-form';
import withAdvancedQuoterHandler from './with_advanced_quoter_handler';
import Quote from './quote';

export default withAdvancedQuoterHandler(
    handleChange(({processing, quotes, results, ...props}) => {
        return (
            <div>
                <div className="p-4">
                    <h3>Quick Quoter</h3>
                    {quotes.map(({quoteId, defaultOrder}, index) => {
                        return (
                            <Quote
                                index={index}
                                isLastQuote={index + 1 === quotes.length}
                                quoteId={quoteId}
                                key={quoteId}
                                defaultOrder={defaultOrder}
                                onDeleteQuote={props.onDeleteQuote}
                                onAddQuote={props.onAddQuote}
                            />
                        );
                    })}
                </div>
            </div>
        );
    })
);
